import {
  SEARCH_PRODUCT_ON_LOAD,
  SEARCH_PRODUCT_ON_LOAD_SUCCESS,
  SEARCH_PRODUCT_FILTER,
  SEARCH_PRODUCT_FILTER_SUCCESS,
  SEARCH_PRODUCT_ON_RESET,
  TIER_FEE_ON_SUCCESS,
  TIER_FEE_ON_FAILED,
  CORRIDOR_REF_ON_SUCCESS,
  CORRIDOR_REF_ON_FAILED,
  PRODUCT_DETAIL_ON_RESET,
  PRODUCT_UPDATE_ON_LOAD,
  PRODUCT_UPDATE_ON_SUCCESS,
  PRODUCT_UPDATE_ON_FAILED,
  UPDATE_TIER_FEE,
  UPDATE_TIER_FEE_ON_SUCCESS,
  UPDATE_TIER_FEE_ON_FAILED,
  REQUEST_SELECTED_HUB_ON_LOAD,
  REQUEST_SELECTED_HUB_ON_SUCCESS,
  REQUEST_SELECTED_HUB_ON_FAILED,
  REQUEST_SELECTED_HUB_ON_RESET,
  ADD_NEWBANK_TO_CORRIDOR,
  ADD_NEWBANK_TO_CORRIDOR_SUCCESS,
  ADD_NEWBANK_TO_CORRIDORS,
  ADD_NEWBANK_TO_CORRIDORS_SUCCESS,
  UPDATE_BANK_IN_CORRIDOR,
  UPDATE_BANK_IN_CORRIDOR_SUCCESS,
  ADD_NEWBANK_TO_ISSUERML,
  ADD_NEWBANK_TO_ISSUERML_SUCCESS,
  UPDATE_BANK_IN_ISSUERML,
  UPDATE_BANK_IN_ISSUERML_SUCCESS,
  ISSUER_ML_FETCH_SUCCESS,
  ISSUER_ML_DATA_RESET,
  ISSUER_FETCH_SUCCESS,
  ISSUER_DATA_RESET,
  SUBMIT_TIER_FEE_REQUEST_SUCCESS,
  FETCH_REQUEST_FLOW_SUCCESS,
  FETCH_ISSUERS_BY_COUNTRY_STATUS_SUCCESS,
  FETCH_ISSUERS_BY_COUNTRY_STATUS_FAILED,
  REQUEST_ISSUERS_BY_COUNTRY_STATUS_FAILED,
  REQUEST_ISSUERS_BY_COUNTRY_STATUS_SUCCESS,
  FETCH_WALLETS_BY_COUNTRY_STATUS_SUCCESS,
  FETCH_WALLETS_BY_COUNTRY_STATUS_FAILED,
  REQUEST_WALLETS_BY_COUNTRY_STATUS_FAILED,
  REQUEST_WALLETS_BY_COUNTRY_STATUS_SUCCESS,
  LAST_MESSAGE_RESET,
  RECIEVING_COUNTRIES_ON_SUCCESS,
  RECIEVING_COUNTRIES_ON_FAILED
} from './actions';

const initialState = {
  selectLoad: false,
  selectData: null,
  filterData: null,
  params: null,
  detailsData: null,
  currentServiceId: null,
  currentTierFeeData: null,
  currentReferencesData: null,
  updateProductLoading: false,
  updateProductResult: null,
  updateTierFeeLoading: false,
  requestSelectedHubLoading: false,
  isRequestSelectedHubSuccess: null,
  messageType: null,
  lastMessage: null,
  fetchNewBankData: null,
  updateCorridorLoading: false,
  issuerMldata: null,
  issuerData: null,
  corrBankSubmitMsg: null,
  issuerMLBankSubmitMsg: null,
  submitTierFeeSuccess: false,
  requestFlowId: null,
  lastSubmittedHubResponse: null,
  issuerMLListWithCountryAndStatus: null,
  recievingCountries: null
}

const updateFilterDate = (filterData, updateProductResult) => {
  const objIndex = filterData.findIndex(obj => obj.remitServiceId === updateProductResult['serviceId']);
  filterData[objIndex].status = updateProductResult['status'];
  filterData[objIndex].minAmount = updateProductResult['minAmount'];
  filterData[objIndex].maxAmount = updateProductResult['maxAmount'];
  filterData[objIndex].serviceNameDisplay = updateProductResult['serviceNameDisplay'];
  return filterData
}

export function productManagementReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case SEARCH_PRODUCT_ON_LOAD:
      return {
        ...state,
        selectLoad: false
      }

    case SEARCH_PRODUCT_ON_LOAD_SUCCESS:
      return {
        ...state,
        selectData: data,
        selectLoad: true
      }

    case SEARCH_PRODUCT_FILTER:
      return {
        ...state,
        params: data
      }

    case SEARCH_PRODUCT_FILTER_SUCCESS:
      return {
        ...state,
        filterData: data
      }
    case SEARCH_PRODUCT_ON_RESET:
      return {
        ...state,
        filterData: null
      }
    case TIER_FEE_ON_SUCCESS:
      return {
        ...state,
        currentServiceId: data.serviceId,
        currentTierFeeData: data.additional
      }
    case TIER_FEE_ON_FAILED:
      return {
        ...state,
        messageType: 'error',
        lastMessage: data
      }
    case RECIEVING_COUNTRIES_ON_SUCCESS:
      return {
        ...state,
        recievingCountries: data
      }
    case RECIEVING_COUNTRIES_ON_FAILED:
      return {
        ...state,
        messageType: 'error',
        lastMessage: data
      }
    case CORRIDOR_REF_ON_SUCCESS:
      return {
        ...state,
        currentReferencesData: data.additional,
        corrBankSubmitMsg: null
      }
    case CORRIDOR_REF_ON_FAILED:
      return {
        ...state,
        messageType: 'error',
        lastMessage: data
      }
    case PRODUCT_DETAIL_ON_RESET:
      return {
        ...state,
        currentServiceId: null,
        currentReferencesData: null,
        messageType: null,
        currentTierFeeData: null
      }
    case PRODUCT_UPDATE_ON_LOAD:
      return {
        ...state,
        updateProductLoading: true
      }
    case PRODUCT_UPDATE_ON_SUCCESS:
      return {
        ...state,
        updateProductLoading: false,
        messageType: "success",
        lastMessage: `Update product status successful for serviceId: ${data.serviceId}`,
        updateProductResult: data,
        filterData: updateFilterDate(state.filterData, data)
      }
    case PRODUCT_UPDATE_ON_FAILED:
      return {
        ...state,
        updateProductLoading: false,
        updateProductResult: null,
        messageType: 'error',
        lastMessage: data.message
      }
    case UPDATE_TIER_FEE:
      return {
        ...state,
        updateTierFeeLoading: true
      }
    case UPDATE_TIER_FEE_ON_SUCCESS:
      return {
        ...state,
        updateTierFeeLoading: false,
        messageType: "success",
        lastMessage: `Update product tierFee successful for serviceId: ${data.serviceId}`,
        updateProductTierFeeResult: data,
        currentTierFeeData: data
        // filterData: updateFilterDate(state.filterData, data)
      }
    case UPDATE_TIER_FEE_ON_FAILED:
      return {
        ...state,
        updateTierFeeLoading: false,
        updateProductResult: null,
        messageType: 'error',
        lastMessage: data.message
      }
    case ADD_NEWBANK_TO_CORRIDOR:
      return {
        ...state,
        updateCorridorLoading: true
      }
    case ADD_NEWBANK_TO_CORRIDOR_SUCCESS:
      return {
        ...state,
        updateCorridorLoading: false,
        corrBankSubmitMsg: 'Bank added/updated successfully',
        currentReferencesData: data,
        newIssuerMldata: [],
        newCorridorReference: [],
        newBanksToOnBoard: null,
        newBanksToOnBoardReadyToShow: false
      }
    
      case ADD_NEWBANK_TO_CORRIDORS:
        return {
          ...state,
          updateCorridorLoading: true
        }
      case ADD_NEWBANK_TO_CORRIDORS_SUCCESS:
        return {
          ...state,
          updateCorridorLoading: false,
          corrBankSubmitMsg: 'Bank added/updated successfully',
          currentReferencesListData: data,
          newIssuerMldata: [],
          newCorridorReference: [],
          newBanksToOnBoard: null,
          newBanksToOnBoardReadyToShow: false
        }
    case UPDATE_BANK_IN_CORRIDOR:
      return {
        ...state,
        updateCorridorLoading: true
      }
    case UPDATE_BANK_IN_CORRIDOR_SUCCESS:
      return {
        ...state,
        updateCorridorLoading: false,
        currentReferencesData: data,
        corrBankSubmitMsg: 'Bank added/updated successfully'
      }
    case ADD_NEWBANK_TO_ISSUERML:
      return {
        ...state,
        updateCorridorLoading: true
      }
    case ADD_NEWBANK_TO_ISSUERML_SUCCESS:
      return {
        ...state,
        updateCorridorLoading: false,
        issuerMLBankSubmitMsg: 'Bank added/updated successfully',
        newIssuerMldata: data
      }
    case UPDATE_BANK_IN_ISSUERML:
      return {
        ...state,
        updateCorridorLoading: true
      }
    case UPDATE_BANK_IN_ISSUERML_SUCCESS:
      return {
        ...state,
        updateCorridorLoading: false,
        issuerMLBankSubmitMsg: 'Bank added/updated successfully',
        newIssuerMldata: data
      }
    case ISSUER_ML_FETCH_SUCCESS:
      return {
        ...state,
        issuerMLBankSubmitMsg: null,
        issuerMldata: data.additional
      }
    case ISSUER_ML_DATA_RESET:
      return {
        ...state,
        issuerMldata: null
      }
    case ISSUER_FETCH_SUCCESS:
      return {
        ...state,
        issuerData: data.additional
      }
    case ISSUER_DATA_RESET:
      return {
        ...state,
        issuerData: null
      }
    case REQUEST_SELECTED_HUB_ON_LOAD:
      return {
        ...state,
        requestSelectedHubLoading: true
      }
    case REQUEST_SELECTED_HUB_ON_SUCCESS:
      return {
        ...state,
        requestSelectedHubLoading: false,
        isRequestSelectedHubSuccess: true,
        messageType: "success",
        lastMessage: `Send request successful`,
        lastSubmittedHubResponse: data
      }
    case REQUEST_SELECTED_HUB_ON_FAILED:
      return {
        ...state,
        requestSelectedHubLoading: false,
        isRequestSelectedHubSuccess: false,
        lastSubmittedHubResponse: null,
        updateProductResult: null,
        messageType: 'error',
        lastMessage: data.message
      }
    case REQUEST_SELECTED_HUB_ON_RESET:
      return {
        ...state,
        isRequestSelectedHubSuccess: null,
        lastSubmittedHubResponse: null,
        updateProductResult: null,
        messageType: null,
        lastMessage: null
      }
    case SUBMIT_TIER_FEE_REQUEST_SUCCESS:
      return {
        ...state,
        submitTierFeeSuccess: true,
        submitTierFeeError: null,
        messageType: "success",
        lastMessage: "Submit tier fee request successfully",
      }
    case FETCH_REQUEST_FLOW_SUCCESS:
      return {
        ...state,
        requestFlowId: action.payload
      }

    case FETCH_ISSUERS_BY_COUNTRY_STATUS_SUCCESS:
      return {
        ...state,
        issuerMLListWithCountryAndStatus: action.payload.sort((a, b) => a.issuerId - b.issuerId)
      }
    case FETCH_ISSUERS_BY_COUNTRY_STATUS_FAILED:
      return {
        ...state,
        messageType: 'error',
        issuerMLListWithCountryAndStatus: null,
        lastMessage: data.message
      }
    
    case REQUEST_ISSUERS_BY_COUNTRY_STATUS_SUCCESS:
      return {
        ...state,
        messageType: 'success',
        lastMessage: data.message
      }
    
    case REQUEST_ISSUERS_BY_COUNTRY_STATUS_FAILED:
      return {
        ...state,
        messageType: 'error',
        lastMessage: data.message
      }

    case FETCH_WALLETS_BY_COUNTRY_STATUS_SUCCESS:
      return {
        ...state,
        walletListWithCountryAndStatus: action.payload.sort((a, b) => a.remitServiceId - b.remitServiceId)
      }

    case FETCH_WALLETS_BY_COUNTRY_STATUS_FAILED:
      return {
        ...state,
        messageType: 'error',
        lastMessage: data.message
      }
    
    case REQUEST_WALLETS_BY_COUNTRY_STATUS_SUCCESS:
      return {
        ...state,
        messageType: 'success',
        lastMessage: data.message
      }
    
    case REQUEST_WALLETS_BY_COUNTRY_STATUS_FAILED:
      return {
        ...state,
        messageType: 'error',
        lastMessage: data.message
      }

    case LAST_MESSAGE_RESET:
      return {
        ...state,
        messageType: null,
        lastMessage: null
      }

    default:
      return state;
  }
}